import React from 'react';
import PropTypes from 'prop-types';

import './FieldRadioGroupBar.sass';

import cx from 'classnames';

export default class FieldRadioGroupBar extends React.PureComponent {
  render() {
    const {compact, optionGroupId, input, choices} = this.props;

    return (
      <div className={cx('field-radio-group-bar', compact && 'field-radio-group-bar--compact')}>
        {choices.map(choice => {
          let id = '';

          if (optionGroupId) {
            id += `${optionGroupId}_`;
          }

          id += choice.code;

          return (
            <div key={choice.code} className="field-radio-group-bar__radio">
              <input
                id={id}
                type="radio"
                name={input.name}
                value={choice.code}
                checked={choice.code == input.value}
                onChange={input.onChange}
              />
              <label htmlFor={id}>
                {choice.label}
              </label>
            </div>
          )
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/fields/fieldRadioGroupBar/FieldRadioGroupBar.js